<template>
  <div class="board ma-0">
    
  </div>
</template>
<script>
import BacteriaGrowth from "@/components/BacteriaGrowth.vue";
import Respiration from "@/components/Respiration.vue";
import Photosynthesis from "@/components/Photosynthesis.vue";

export default {
  name: "board",
  components: {
    BacteriaGrowth,
    Respiration,
    Photosynthesis,
  },
  data: function () {
    return {
      name: "",
      role: null,
    };
  },
  mounted: function () {
    this.$ga.page("/board/" + this.$route.params.experiment_name);
    this.name = this.$route.params.experiment_name;
    var ga_counter = 0;
/*
    setInterval(function () {
      ga_counter += 10;
      this.$ga.event(
        "Experiment",
        "stay_" + ga_counter + "_mins",
        this.$route.params.experiment_name
      );
    }, 10 * 60 * 1000);
*/    
  },
  methods: {
    enterLab: function(slot_id, equipment_id, role){
      var self = this;
      self.$ga.event('Booking', 'enter_lab', self.$route.params.experiment_name, role);
      apiService.enterLab(slot_id, self.$cookies.get('auth_token'),role)
      .then((response) => {
          if(response.status == "fail"){
              self.$store.commit('showSnackBar', response.message);
          }else{
              self.$store.commit('showSnackBar', "Preparing...");
              self.$cookies.set('session_token', response.session_token);
              self.$cookies.set('role', role);
              var kick_time = 3600-60-parseInt(moment().format("mm"))*60-parseInt(moment().format("ss"));    //in seconds to next hour (-1 min)
              self.$cookies.set('kick_time', kick_time);
              self.$cookies.set('experiment', self.$route.params.experiment_name);
              self.$cookies.set('equipment_id', equipment_id);
              self.$router.push("/experiment/"+self.$route.params.experiment_name);
          }
      });
    }
  },
};
</script>

<style lang="scss">
.clickable {
  cursor: pointer;
}
</style>